import uuidv4 from 'uuid/v4';
import store from './store';

function _performRouterCheckInitialStepComplete(to, next) {
    if (!store.state.permitValidated) {
        next('/');
    }
    else if (store.state.isZeroFacilityUsagesReportSubmission) {
        next(`/${to.params.permitNumber}/${to.params.permitYear}/no-usage-confirmation`);
    }
    else {
        next();
    }
}

export function routerCheckInitialStepComplete(to, from, next) {
    if (!store.state.persistentStorageChecked || from.name === 'initial-form') {
        store.dispatch('validateAndSetPermitNumber', {
            permitNumber: to.params.permitNumber,
            permitYear: to.params.permitYear
        })
        .then(function () {
            return store.dispatch('initializeStore', {
                permitNumber: to.params.permitNumber,
                permitYear: to.params.permitYear
            });
        })
        .then(function () {
            _performRouterCheckInitialStepComplete(to, next);
        });
    }
    else {
        _performRouterCheckInitialStepComplete(to, next);
    }
}

export function routerCheckIsZeroUsageReportSubmission(to, from, next) {
    if (!store.state.permitValidated) {
        next('/');
    }
    else if (!store.state.isZeroFacilityUsagesReportSubmission) {
        next(`/${to.params.permitNumber}/${to.params.permitYear}`);
    }
    else {
        next();
    }
}

export function routerCheckFacilityUsageExists(to, from, next) {
    if (to.name === 'add-activity' || store.getters.getFacilityUsage(to.params.index)) {
        next();
    }
    else {
        next(`/${to.params.permitNumber}/${to.params.permitYear}`);
    }
}

export function rebindFormValidation() {
    const $forms = $(`form.unobtrusive-validate`);

    $forms.each(function () {
        $.data($(this)[0], 'validator', false);
    });

    $.validator.unobtrusive.parse($forms);
}

export function generateIndex() {
    return uuidv4();
}

export function postSaveActivityForm(endpoint, { baseUrl, requestVerificationToken, permitNumber, permitYear, permitValidated, facilityUsages, email, zeroFacilityUsagesReport, isZeroFacilityUsagesReportSubmission }) {
    return $.post(`${baseUrl}${endpoint}`, {
        __RequestVerificationToken: requestVerificationToken,
        LASNumber: permitNumber,
        PermitValidated: permitValidated,
        PermitYear: permitYear,
        BusinessName: null,
        ContactPerson: null,
        Email: email,
        ZeroFacilityUsagesReport: zeroFacilityUsagesReport,
        IsZeroFacilityUsagesReportSubmission: isZeroFacilityUsagesReportSubmission,
        FacilityUsages: !zeroFacilityUsagesReport && facilityUsages && facilityUsages.length ? facilityUsages.map(u => {
            return {
                AreaId: u.areaId,
                AreaName: u.areaName,
                FacilityId: u.facilityId,
                FacilityName: u.facilityName,
                ActivityId: u.activityId,
                ActivityName: u.activityName,
                ClientDays: u.clientDays,
                Fee: u.feePaid,
                FeeBasis: u.feeBasis,
                Index: u.index
            };
        }) : []
    });
}

export function redirectToPayments(paymentData) {
    const { gatewayUrl, payment } = paymentData;

    $('body').remove('form#payment-form').append(`
        <form name="payment-form" id="payment-form" action="${gatewayUrl}" method="post" style="display: none; ">
            <input type="hidden" name="x0" value="${payment.x0}" />
            <input type="hidden" name="x1" value="${payment.x1}" />
            <input type="hidden" name="x2" value="${payment.x2}" />
            <input type="hidden" name="x3" value="${payment.x3}" />
            <input type="hidden" name="x4" value="${payment.x4}" />
            <input type="hidden" name="x5" value="${payment.x5}" />
            <input type="hidden" name="x6" value="${payment.x6}" />
            <input type="hidden" name="x7" value="${payment.x7}" />
            <input type="hidden" name="x8" value="${payment.x8}" />
            <input type="hidden" name="address1" value="${payment.address1}" />
            <input type="hidden" name="address2" value="${payment.address2}" />
            <input type="hidden" name="city" value="${payment.city}" />
            <input type="hidden" name="country_code" value="${payment.country_code}" />
            <input type="hidden" name="email_addr" value="${payment.email_addr}" />
            <input type="hidden" name="first_name" value="${payment.first_name}" />
            <input type="hidden" name="last_name" value="${payment.last_name}" />
            <input type="hidden" name="phone_number" value="${payment.phone_number}" />
            <input type="hidden" name="postal_code" value="${payment.postal_code}" />
            <input type="hidden" name="stateprov" value="${payment.stateprov}" />
        </form>
    `);

    $('form#payment-form').submit();
}